export default __webpack_public_path__ + "static/media/zarya-icon.2f71ebd2.webp";